import { render, staticRenderFns } from "./ProfileEditor.vue?vue&type=template&id=255227b2"
import script from "./ProfileEditor.vue?vue&type=script&lang=js"
export * from "./ProfileEditor.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditor.vue?vue&type=style&index=0&id=255227b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports